import React from 'react';
import isNil from 'lodash-es/isNil';
import { gql } from '@yi/core';

import { graphql, useStaticQuery } from 'gatsby';
import { ClassCarousel } from '~/src/components/carousels/ClassCarousel';

import { sortCardsByIds } from '../sortCardsByIds';

interface Props {
  children: (data: React.ComponentProps<typeof ClassCarousel>['items']) => React.ReactNode;
}
const list = [
  '586Tju6z3Zy3b8VuMeochh',
  '2523609',
  'bhofkEaOv1YeWDet79Kgl',
  '2658318',
  '4ab3HSW2MvL73RXJffCmJJ',
  '1Mn4sueCASQGqhvoqTfylF',
  '6sGVQqXArrT5CnfIyuT7Ew',
  '2mBjOsaM5fX3yPBGVHuxF9',
  '2WbqcjecgJZLIitTfLAPdw',
  '32UmVI8dUSZDhv5SHHzrVw',
  '2430549',
  '5464995',
];

export const YogaCarouselDataES: React.FC<Props> = ({ children }) => {
  const yiData = useStaticQuery<gql.typesSsr.Query_AllClasses_LOH_ES>(graphql`
    query Query_AllClasses_LOH_ES {
      yi {
        allClasses(
          filter: {
            ids: [
              "586Tju6z3Zy3b8VuMeochh"
              "2523609"
              "bhofkEaOv1YeWDet79Kgl"
              "2658318"
              "4ab3HSW2MvL73RXJffCmJJ"
              "1Mn4sueCASQGqhvoqTfylF"
              "6sGVQqXArrT5CnfIyuT7Ew"
              "2mBjOsaM5fX3yPBGVHuxF9"
              "2WbqcjecgJZLIitTfLAPdw"
              "32UmVI8dUSZDhv5SHHzrVw"
              "2430549"
              "5464995"
            ]
          }
        ) {
          ...Fragment_ClassCard
        }
      }
    }
  `);

  const data = yiData?.yi?.allClasses;
  if (isNil(data)) {
    return null;
  }
  const sortedClassesData = sortCardsByIds(data, list);

  return <>{children(sortedClassesData)}</>;
};
